import React, { FC, useContext } from 'react'
import { Container } from '@mch-group/uikit-components'
import { Button } from '@mch-group/uikit-components'
import { LoginContext } from '@providers/Login'
import classNames from 'classnames'
import styled from 'styled-components'
import Separator from '@components/Separator'
import px2rem from '../../utils/px2rem'
import Text from '../Text'

interface SigninProps {
  className: string
  signin_grp1_content: string
  signin_grp1_button: string
  currentPageUrl: string
  isLoggedIn: boolean
}

const SignIn: FC<SigninProps> = (props) => {
  const { showLogin, user } = useContext(LoginContext)

  const isLoggedIn = user?.loginData && true

  if (isLoggedIn) return null

  return (
    <>
      <Container as='section' className={classNames(props.className)}>
        <div className='d-block d-md-flex justify-content-between align-items-center px-5 px-lg-8 px-md-7 '>
          <Text isHtml>{props.signin_grp1_content}</Text>
          <div className='d-flex mt-8 justify-content-end mt-md-0'>
            <Button
              size='compact'
              onClick={() =>
                showLogin({
                  onLoginSuccessCallback: () => window.location.reload()
                })
              }
            >
              {props.signin_grp1_button}
            </Button>
          </div>
        </div>
      </Container>
      <Separator />
    </>
  )
}

export default styled(SignIn)`
  margin-top: ${px2rem(-24)};
  margin-bottom: ${px2rem(32)};
`
